import Placeholder from '@tiptap/extension-placeholder'

export const EditorPlaceholder = Placeholder.configure({
  placeholder:
    'Write or paste your text here, then click ‘Review’ to get suggestions. You can also highlight any text to paraphrase, shorten, expand, or find synonyms.',
  showOnlyWhenEditable: false,
})
